<template>
  <div id="userIngo">
    <div class="box">
      <div class="left">
        <p>{{ userInfo && userInfo.nickname[0] }}</p>
      </div>
      <div class="right">
        <p class="style">
          {{ userInfo && userInfo.roleName }}
        </p>
        <p class="department">
          {{ userInfo && userInfo.departmentName }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "userIngo",
  components: {},
  data() {
    return {
      userInfo: ''
    };
  },
  watch: {
    '$store.state.userInfo'() {
      this.userInfo = this.$store.state.userInfo;
    },
  },
};
</script>

<style scoped>
#userIngo {
  margin-bottom: 16px;
}
#userIngo .box {
  display: flex;
  align-items: center;

  padding: 0 20px;
  box-sizing: border-box;
}

#userIngo .box .left {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: chocolate;

  margin-right: 16px;
}

#userIngo .box .left p {
  line-height: 60px;
  text-align: center;
  font-size: 20px;
  font-weight: 600;
  color: #fff;
}

#userIngo .box p {
  color: rgb(179, 179, 179);
  line-height: 22px;
  font-size: 14px;
}

#userIngo .box p.department {
  font-size: 16px;
  color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/osNav/components/userInfo.vue